import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  title: 'Comunicación profesional con familias',
  image: 'https://cdn.magicpatterns.com/uploads/ccvb2E55gmPohubKWYj8nz/bono_1_comunicacion_con_famillias-removebg-preview.png'
}, {
  title: 'Sistema de organización del caso clínico',
  image: 'https://cdn.magicpatterns.com/uploads/8sMcYMupvvMnXkpeK7TAzs/mock_up_2_sistema_de_organizacion_clinico-removebg-preview.png'
}, {
  title: 'Guía de manejo de sesiones complejas',
  image: 'https://cdn.magicpatterns.com/uploads/m6t6WDBSrkRBmhzGk4RPCM/26ec149f-0e11-43df-bcc7-8d5df33c0bb6-removebg-preview.png'
}];
export function BonusSection() {
  const checkoutUrl = 'https://fonocheck.librosdigitales.pro/cart/44768212975752:1';
  return <section className="py-20 bg-[#EDF2F7]" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-3">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#C9A84C] rounded-full mb-6 shadow-lg" data-id="element-4">
            <GiftIcon className="w-8 h-8 text-white" data-id="element-5" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-6">
            🎁 BONOS INCLUIDOS
          </h2>
          <p className="text-xl text-gray-600" data-id="element-7">
            Todo incluido. Gratis por el día de hoy.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-8">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} onClick={() => document.getElementById('compra')?.scrollIntoView({
          behavior: 'smooth'
        })} className="cursor-pointer group" data-id="element-9">
              <div className="relative bg-white rounded-xl shadow-lg overflow-hidden flex flex-col items-center p-6" data-id="element-10">
                {/* GRATIS Badge */}
                <div className="absolute top-4 right-4 bg-[#C9A84C] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md z-10" data-id="element-11">
                  GRATIS POR HOY
                </div>

                {/* Bonus Image */}
                <img src={bonus.image} alt={bonus.title} loading="lazy" decoding="async" className="w-full max-w-[220px] h-auto object-contain mb-4 group-hover:scale-105 transition-transform duration-300 drop-shadow-lg" data-id="element-12" />

                {/* Title */}
                <h3 className="text-gray-900 text-lg font-bold leading-tight text-center" data-id="element-13">
                  {bonus.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}